import { render } from "./HeroiconsOutlineInboxIn.vue?vue&type=template&id=611d796c"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineInboxIn.vue"]])

export default __exports__